import { gql } from '@grandvisionhq/graphql';
import { productPriceItemFragment } from './prices/productPriceItem.js';
import './prices/productPrice.js';
import { mediaFragment } from './small-fragments.js';

const variantFragment = gql`
  fragment variantFragment on Variant {
    description
    displayName
    erpId
    header
    isAllowBackOrder
    isAvailableForSubscription
    isExcludedFromCheckout
    isPublished
    metaTitle
    metaDescription
    opcoBackendId
    sku
    usps
    media {
      ...mediaFragment
    }
    priceList {
      ...productPriceItemFragment
    }
    bestPrice
    inventory {
      items {
        channel {
          key
          id
        }
        quantity
      }
      totalQuantity
    }
  }
  ${mediaFragment}
  ${productPriceItemFragment}
`;

export { variantFragment };
//# sourceMappingURL=variant.js.map
